const tagManagerId = 'GTM-KZ7SM8KR';
const cookieInformationElem = document.querySelector('#cookies-information');
let checkboxEls;
export const STORAGE_KEY = 'braha_acceptedCookies';
export const EVENT_ACCEPTED_COOKIES_CHANGED = 'braha_acceptedCookiesChanged';
export var COOKIE_TYPE;
(function (COOKIE_TYPE) {
    COOKIE_TYPE["REQUIRED"] = "required";
    COOKIE_TYPE["TRACKING"] = "tracking";
    COOKIE_TYPE["YOUTUBE"] = "youtube";
})(COOKIE_TYPE || (COOKIE_TYPE = {}));
export function setAcceptedCookies(cookies) {
    // Remove duplicates, include required cookies by default
    cookies = Array.from(new Set([...cookies, COOKIE_TYPE.REQUIRED]));
    // Persist in a cookie
    window.localStorage.setItem(STORAGE_KEY, cookies.join(','));
    if (window.gtag) {
        window.gtag('consent', 'update', {
            ad_storage: cookies.includes(COOKIE_TYPE.TRACKING) ? 'granted' : 'denied',
            ad_user_data: cookies.includes(COOKIE_TYPE.TRACKING) ? 'granted' : 'denied',
            ad_personalization: cookies.includes(COOKIE_TYPE.TRACKING) ? 'granted' : 'denied',
            analytics_storage: cookies.includes(COOKIE_TYPE.TRACKING) ? 'granted' : 'denied',
        });
    }
    // Mark respective checkboxes as checked
    updateCheckboxState();
    /**
     * Tracking
     */
    if (cookies.includes(COOKIE_TYPE.TRACKING)) {
        if (process.env.NODE_ENV === 'production' && window.location.hostname !== '127.0.0.1') {
            // TODO add production GTM snippet (replace GTM-ID with `tagManagerId` variable)
            window[`ga-disable-${tagManagerId}`] = false;
            window.dataLayer.push({ event: 'cookies_accepted' });
        }
    }
    else {
        window[`ga-disable-${tagManagerId}`] = true;
    }
    hideCookieBanner();
    window.dataLayer.push({ event: EVENT_ACCEPTED_COOKIES_CHANGED });
    window.dispatchEvent(new CustomEvent(EVENT_ACCEPTED_COOKIES_CHANGED, {
        detail: { acceptedCookies: cookies },
    }));
}
export function getAcceptedCookies() {
    try {
        return window.localStorage.getItem(STORAGE_KEY)?.split(',');
    }
    catch (e) {
        return [COOKIE_TYPE.REQUIRED];
    }
}
function updateCheckboxState() {
    const cookies = getAcceptedCookies();
    if (cookies) {
        checkboxEls.forEach(checkboxEl => (checkboxEl.checked = cookies.includes(checkboxEl.value)));
    }
}
const PATHS_HIDE_BANNER = [/privacy/, /datenschutz/, /privacy-policy/];
// Setup cookiebanner events
function setup() {
    window.hatchery = window.hatchery ?? {};
    window.hatchery.cookies = window.hatchery.cookies ?? {};
    window.hatchery.cookies.initialized = true;
    if (!cookieInformationElem) {
        return;
    }
    checkboxEls = Array.from(cookieInformationElem.querySelectorAll('.checkboxes-container input'));
    updateCheckboxState();
    // Logic to only activate selected cookies
    cookieInformationElem.querySelector('#btn-accept-selected')?.addEventListener('click', () => {
        const acceptedCookieTypes = Array.from(checkboxEls)
            .map(el => (el.checked ? el.value : null))
            .filter(val => !!val);
        setAcceptedCookies(acceptedCookieTypes);
        window.dataLayer.push({ event: 'cookies_btn_accept_selected_clicked' });
    });
    cookieInformationElem.querySelector('#btn-accept-all')?.addEventListener('click', () => {
        setAcceptedCookies(Object.values(COOKIE_TYPE));
        window.dataLayer.push({ event: 'cookies_btn_accept_all_clicked' });
    });
    // Show popup if user is trying to unselect the required option
    cookieInformationElem
        .querySelector('label[for="required-cookies"]')
        ?.addEventListener('click', function () {
        alert(this.title);
    });
    if (window.localStorage.getItem(STORAGE_KEY)) {
        const acceptedCookies = window.localStorage.getItem(STORAGE_KEY)?.split(',');
        setAcceptedCookies(acceptedCookies);
    }
    else {
        const { pathname } = window.location;
        const bannerHiddenDuePath = PATHS_HIDE_BANNER.some(condition => {
            if (typeof condition === 'string') {
                return pathname.includes(condition);
            }
            else {
                condition.test(pathname);
            }
        });
        if (bannerHiddenDuePath) {
            hideCookieBanner();
        }
        else {
            showCookieBanner();
        }
    }
}
export function showCookieBanner() {
    if (cookieInformationElem) {
        cookieInformationElem.style.display = 'flex';
    }
}
export function hideCookieBanner() {
    if (cookieInformationElem) {
        cookieInformationElem.style.display = 'none';
    }
}
// Setup dataLayer
window.dataLayer = window.dataLayer || [];
// Ensure setup code only runs once
window.hatchery = window.hatchery ?? {};
window.hatchery.cookies = window.hatchery.cookies ?? {};
if (window.hatchery?.cookies?.initialized !== true) {
    setup();
}
